export default "__VITE_ASSET__DiUbHhOq__"